export default __webpack_public_path__ + "static/Laptop_workflow-ba0e758a377317be9905d598b8b2c4ad.png";